import React from 'react'
import { styled } from '../../stitches/stitches.config'
import { parseTime, restTimeToNextUpdate } from '../../utils/date'
import { useActions } from '@stackflow/react'
import { PageCode } from '../../stackflow/activities'
import CountDownImage from '../../images/countdown.png'
import { keyframes } from '@stitches/react'

const PageFeedCountDown: React.FC = () => {
  const { replace } = useActions()
  const [time, setTime] = React.useState<{
    h: number
    m: number
    s: number
  } | null>(null)

  const handleTwoDigit = (n: number) => {
    return n < 10 ? `0${n}` : n
  }

  React.useEffect(() => {
    const updateTime = () => {
      const {
        hours: h,
        minutes: m,
        seconds: s,
      } = parseTime(restTimeToNextUpdate())

      if ([h, m, s].every((v) => v === 0) || [h, m, s].some((v) => v < 0))
        return

      setTime({ h, m, s })
    }

    updateTime()
    const timer = window.setInterval(updateTime, 1000)

    return () => {
      window.clearInterval(timer)
    }
  }, [])

  React.useEffect(() => {
    if (!(time?.h === 0 && time?.m === 0 && time?.s === 1)) return

    const clearId = window.setTimeout(() => {
      replace(PageCode.FEED, {}, { animate: false })
    }, 1500)

    return () => {
      window.clearTimeout(clearId)
    }
  }, [time?.h, time?.m, time?.s])

  if (!time) return null

  const timeState =
    time.h > 0 || time.m > 0
      ? 'OVER_A_MINUTE'
      : time.s <= 10
      ? 'LAST_TEN_SECONDS'
      : 'UNDER_A_MINUTE'

  return (
    <Container>
      <ImageContainer>
        <Image src={CountDownImage} />
        <CircleLight time={timeState} />
        <RightSign time={timeState} />
      </ImageContainer>
      <Time>{[time.h, time.m, time.s].map(handleTwoDigit).join(' : ')}</Time>
    </Container>
  )
}

export default PageFeedCountDown

const Container = styled('div', {
  flex: 1,
  overflow: 'hidden',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: '$gray900',
  fontSize: '24px',
  fontWeight: 'bold',
})

const ImageContainer = styled('div', {
  position: 'relative',
})

const Image = styled('img', {
  width: '90vw',
  height: '90vw',
})

const Time = styled('div', {
  position: 'relative',
  bottom: '48px',
})

const flicker = keyframes({
  '0%': { backgroundColor: '#3d3d3d6e' },
  '50%': { backgroundColor: '#ffff006e' },
  '100%': { backgroundColor: '#3d3d3d6e' },
})

const lightFlickerStyle = {
  variants: {
    time: {
      OVER_A_MINUTE: {
        background: '#3d3d3d6e',
      },
      UNDER_A_MINUTE: {
        animation: `${flicker} 10s infinite`,
      },
      LAST_TEN_SECONDS: {
        animation: `${flicker} 1s infinite`,
      },
    },
  },
}

const CircleLight = styled(
  'div',
  {
    position: 'absolute',
    top: '40.9vw',
    left: '38.6vw',
    width: '8.6vw',
    height: '2vw',
  },
  lightFlickerStyle
)

const RightSign = styled(
  'div',
  {
    transform: 'skew(-8deg)',
    position: 'absolute',
    top: '41.4vw',
    left: '66.3vw',
    width: '3.2vw',
    height: '4.2vw',
  },
  lightFlickerStyle
)
